import { render } from "./FlottaPage.vue?vue&type=template&id=6412c85e"
import script from "./FlottaPage.vue?vue&type=script&lang=js"
export * from "./FlottaPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__